export function UploadStage({
  fileName,
  progress,
  phase,
}: {
  fileName: string;
  progress: number;
  phase: "send" | "prepare";
}) {
  const pct = Math.max(6, Math.min(100, progress));
  return (
    <div className="sg-upload" role="status" aria-live="polite">
      <div className="sg-upload__card">
        <div className="sg-upload__sheet" />
        <h2>{phase === "send" ? "Téléversement" : "Ouverture"}</h2>
        <p>
          {phase === "send" ? "Le PDF arrive dans l’atelier." : "Lecture des pages et des cases."}
          <br />
          {fileName}
        </p>
        <div className="sg-upload__track">
          <div className="sg-upload__fill" style={{ width: `${pct}%` }} />
        </div>
      </div>
    </div>
  );
}
